import React from 'react';
import { Box, Typography } from '@mui/material';
import { InfoOutlinedIcon, AddIcon } from 'icons/materialIcons';
import WhiteButtonWithIcon from 'components/common/button/WhiteButtonWithIcon';

const TeamSupportHeader = ({ onInteractiveOnboarding, onRequestFeature }) => {
    return (
        <Box sx={{ p: 3, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="h6">
                How can we help?
            </Typography>

            <Box sx={{ display: 'flex', gap: 2 }}>
                <WhiteButtonWithIcon
                    icon={InfoOutlinedIcon}
                    text="Replay Interactive Onboarding"
                    onClick={onInteractiveOnboarding}
                />
                <WhiteButtonWithIcon
                    icon={AddIcon}
                    text="Request a Feature"
                    onClick={onRequestFeature}
                />
            </Box>
        </Box>
    );
};

export default TeamSupportHeader;

